import React from "react";
import { InlineLoading } from "carbon-components-react";

const getStatusAndDescription = (
  submitting: boolean,
  error: boolean,
  message: string,
): { status: "active" | "error" | "finished"; description: string } => {
  if (submitting) {
    return {
      status: "active",
      description: "Calculating…",
    };
  }
  if (error) {
    return {
      status: "error",
      description:
        message !== "" ? message : "There was a problem loading results! Please contact eng.",
    };
  }
  return {
    status: "finished",
    description: "Ready",
  };
};

const Status = ({
  submitting,
  error,
  message = "",
}: {
  submitting: boolean;
  error: boolean;
  message: string;
}) => <InlineLoading {...getStatusAndDescription(submitting, error, message)} />;

export default Status;
